import { jdiColorFetch } from "../colorFetchV2";
import { OutOfStockResponse, SubscribeType } from "./outofStock.interface";

// 缺货订阅接口
export const outOfStockNotify = async (email: string, skuIds: string[]): Promise<OutOfStockResponse> => {
  const res = await jdiColorFetch(`user_settings_addSubscribeNotify`, {
    method: "post",
    bodyQuery: {
      email,
      skuIds,
      subscribeType: SubscribeType.OutOfStock
    },
  });
  return res;
};
